module.exports = __webpack_public_path__ + "static/img_01-9267b8ed8e67e59e05fd2a8410f49d93.png";